export default __webpack_public_path__ + "static/media/create-propay-icon.97e9f3b8.svg";